module.exports = __webpack_public_path__ + "img/secret-to-open-a.png";